import { watchListLoaded } from '@watch-lists/state/feature/entities/watch-list/watch-list.actions';
import { Injectable } from '@angular/core';
import { ofType } from '@ces/sourced-action/lib/of-type.operator';
import { Actions, createEffect } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { billsForBTaxAccountLoaded } from '../../btax.actions';
import { addBTaxAccountData } from './btax-account.actions';

@Injectable()
export class BTaxAccountEntityEffects
{
    constructor
    (
        // Dependencies

        private readonly actions$: Actions,
    )
    {}


    // Bills for account loaded

    private readonly billsForBTaxAccountLoaded$ = createEffect(() => this.actions$.pipe(
        ofType(billsForBTaxAccountLoaded),
        mergeMap(({ response }) => response
            ? of(addBTaxAccountData(`Effect of ${billsForBTaxAccountLoaded.type}`, { accountsData: response.accounts }))
            : EMPTY
        ),
    ));


    // Watch List details loaded

    private readonly watchListDetailsLoaded$ = createEffect(() => this.actions$.pipe(
        ofType(watchListLoaded),
        filter(a => !!a.response.btax?.accounts.length),
        map(({ response }) => addBTaxAccountData(
            `Effect of ${watchListLoaded.type}`,
            { accountsData: response.btax!.accounts }
        )),
    ));
}
